/**
 * Veeroute.Lastmile
 * Veeroute Lastmile API
 *
 * The version of the OpenAPI document: 3.15.183137
 * Contact: support@veeroute.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Location, geographical location.
 */
export interface LocationLastmile { 
    /**
     * Latitude in degrees.
     */
    latitude: number;
    /**
     * Longitude in degrees.
     */
    longitude: number;
    /**
     * Time for driving up to the location (or waiting time at parking lot) in minutes.
     */
    arrival_duration?: number;
    /**
     * Time to leave the location in minutes.
     */
    departure_duration?: number;
}

